import sanitizeHtml from 'sanitize-html';
import { isJSONString } from './isJSONString';

export function getDescription({
  allowDynamicDescription,
  dynamicDescription,
  productDescription,
  productDescriptionHtml,
  checkoutDescription,
  checkoutDescriptionHtml,
}) {
  if (dynamicDescription && allowDynamicDescription) {
    return sanitizeHtml(dynamicDescription.replace(/\\n/g, '\n'));
  }

  if (typeof productDescriptionHtml === 'string') {
    return productDescriptionHtml;
  } else if (typeof productDescription === 'string' && !isJSONString(productDescription)) {
    // if this is a JSON string, it's lexical editor state before formatted HTML has kicked in
    // we don't want to render it
    return productDescription;
  } else if (typeof checkoutDescriptionHtml === 'string') {
    return checkoutDescriptionHtml;
  } else if (typeof checkoutDescription === 'string' && !isJSONString(checkoutDescription)) {
    // if this is a JSON string, it's lexical editor state before formatted HTML has kicked in
    // we don't want to render it
    return checkoutDescription;
  }

  return '';
}
